import { Controller } from "@hotwired/stimulus"

// Toggles collapsed/expanded state for inline activity editing.
// Hiding the list column-header while a row is expanded is handled purely in
// CSS via :has() (see stylesheets/components/activity-table.css) — no JS needed.
export default class extends Controller {
  static targets = ["display", "form"]

  toggle(event) {
    event.preventDefault()
    const isExpanded = this.formTarget.classList.contains("hidden")

    if (isExpanded) {
      this.displayTarget.classList.add("hidden")
      this.formTarget.classList.remove("hidden")
    } else {
      this.displayTarget.classList.remove("hidden")
      this.formTarget.classList.add("hidden")
    }
  }

  collapse() {
    this.displayTarget.classList.remove("hidden")
    this.formTarget.classList.add("hidden")
  }
}
